import {
  errorNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const addErrandBoy = async (
  payload,
  setLoading,
  setFormValues,
  initialValues,
  onClose
) => {
  try {
    await http.post(AUTH_ROUTES.ADD_ERRAND_BOY, payload);
    setLoading(false);
    setFormValues(initialValues);
    successNotifier("Errand boy Successfully added");
    onClose();
  } catch (e) {
    setLoading(false);
    errorNotifier(e.response?.data.result);
  }
};
